import { Box, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import TextNavigator from "../components/TextNavigator";
import ForgotPassword from "../components/ForgotPassword";

type IProps = {
  for: "login" | "signup";
};

const AuthFooter = (props: IProps) => {
  const navigate = useNavigate();
  if (props.for === "login") {
    return (
      <Box>
        <TextNavigator
          question="Don't have an account?"
          aText="Sign up"
          onClick={() => navigate("/auth/signup")}
        />

        <ForgotPassword />
      </Box>
    );
  }
  return (
    <Box>
      <Box>
        <TextNavigator
          aText="Log in"
          question="Already have an account?"
          onClick={() => navigate("/auth/login")}
        />
        <Text color={"whiteAlpha.900"} textAlign={"center"} fontSize={"small"}>
          By clicking above, I agree to bellu's {" "}
          <HightLightText onClick={() => navigate("/auth/")}>
            Terms
          </HightLightText>{" "}
           and {" "}
          <HightLightText onClick={() => navigate("/auth/")}>
            Privacy Policy
          </HightLightText>
        </Text>
      </Box>
    </Box>
  );
};

export const HightLightText = (props: {
  children: string;
  onClick: () => void;
}) => {
  return (
    <Box
      onClick={props.onClick}
      as={"b"}
      color="whiteAlpha.800"
      cursor={"pointer"}
      textDecoration={"underline"}
    >
      {props.children}
    </Box>
  );
};

export default AuthFooter;
